<template>
    <form class="form" :action="action">
        <div class="form--fieldset-row">
            <form-fieldset class="form--fieldset"
                    v-for="(fieldset, fieldsetIdx) in fieldsets"
                    v-bind="bindFieldsetProps(fieldset)"
                    :key="fieldsetIdx"/>
        </div>
        <div class="form--fieldset-row">
            <div class="form--fieldset form-fieldset">
                <form-general-messages :errors="generalErrors"/>
            </div>
        </div>
    </form>
</template>

<script>
    import { isIE } from 'util/detect/ie-detect/index';
    import { FORM_SUBMISSION_STATE } from 'util/vue/form';
    import FormFieldset from 'framework/components/form/form-fieldset/form-fieldset';
    import FormGeneralMessages from 'framework/components/form/form-general-messages/form-general-messages';

    import bemMixin from 'framework/mixins/bem/index';

    export default {
        components: {
            FormFieldset,
            FormGeneralMessages,
        },
        mixins: [
            bemMixin('form'),
        ],
        inheritAttrs: false,
        props: {
            action: {
                type: String,
                required: true,
            },
            submissionState: {
                type: String,
                required: true,
            },
            successUrl: {
                type: String,
                default: null,
            },
            /** @type {IFormFieldset[]} */
            fieldsets: {
                type: Array,
                required: true,
            },
            /** @type {string[]} */
            generalErrors: {
                type: Array,
                required: true,
            },
            bindFieldsetProps: {
                type: Function,
                required: true,
            },
            onFormSubmit: {
                type: Function,
                required: true,
            },
            /** @type {Promise} */
            submissionRequest: {
                type: Promise,
                default: null,
            },
        },
        methods: {
            /**
             * Handle a success state by redirecting to a determined success page
             */
            redirectToSuccessPage() {
                if (!this.successUrl) {
                    this.$log.warn('Form was sent but there was no success url provided!');
                }

                // NOTE: Allow async promise callbacks to run before we change the route
                // IE11 and below need some more time...
                const delay = isIE ? 200 : 1;

                setTimeout(() => {
                    this.$router.push(this.successUrl);
                }, delay);
            },

            handleFormSubmissionSucceeded() {
                if (this.successUrl) {
                    return this.redirectToSuccessPage();
                }

                return null;
            },
        },
        watch: {
            submissionState: {
                handler(value) {
                    if (value === FORM_SUBMISSION_STATE.SUCCESS) {
                        this.handleFormSubmissionSucceeded();
                    }
                },
            },
        },
    };
</script>
